import * as React from "react";

const BellIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.81 13.577a.89.89 0 0 0 .63-1.09 9.292 9.292 0 0 1 .933-7.097.89.89 0 1 0-1.542-.89 11.059 11.059 0 0 0-1.112 8.447.89.89 0 0 0 1.09.63ZM21.015 8.966a.89.89 0 0 0 .63-1.09 11.06 11.06 0 0 0-5.187-6.76.89.89 0 1 0-.89 1.542 9.29 9.29 0 0 1 4.356 5.679.89.89 0 0 0 1.091.63ZM5.938 19.036a5.965 5.965 0 0 0 .866-4.958L6.16 11.68c-.811-3.027.766-6.135 3.566-7.335l-.249-.93a.89.89 0 1 1 1.72-.46l.25.929c3.026-.361 5.945 1.542 6.756 4.57l.643 2.397a5.971 5.971 0 0 0 3.237 3.866c.412.197.715.561.833 1.002a1.56 1.56 0 0 1-1.102 1.909L7.62 21.43a1.56 1.56 0 0 1-1.683-2.395ZM15.64 22.971a3.345 3.345 0 0 1-3.853-1.734l6.321-1.693a3.345 3.345 0 0 1-2.469 3.427Z"
      fill="currentColor"
    />
  </svg>
);

export default BellIcon;
